module.exports = __webpack_public_path__ + "img/40.a215291d.jpg";